export const ALLOWED_MIMES = ['.pdf', '.csv', '.xlsx', '.jpeg', '.png', '.jpg'];
export const EMAIL_RGX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_RGX = /^\+?[0-9]*$/;
export const FAQ = 'https://gurupayhelp.zendesk.com/hc/en-us';
export const PRICELIST_EN = 'https://gurupay.eu/pricing/';
export const PRICELIST_LT = 'https://gurupay.eu/lt/kainorastis/';
